export const WIDGET_API = "f9d303e83bd841a6a5bbd4c45f34497a";
